/* Mobile board's card; the Main board's sizes from 1024 px. */
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--card);
  border-radius: var(--radius-card);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

.image {
  display: block;
  width: 100%;
  height: 210px;
  object-fit: cover;
  background: var(--band);
}

.noImage {
  background: var(--border-strong);
}

/* The <picture> around a card image with a desktop copy: no box of its own, so
   the <img> stays the card's flex item. */
.picture {
  display: contents;
}

/* Above the stretched title link. */
.save {
  position: absolute;
  z-index: 1;
  top: 8px;
  right: 8px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  filter: drop-shadow(0 1px 2px rgba(var(--ink-rgb), 0.35));
}

.save:hover {
  color: #ffffff;
  transform: scale(1.08);
}

.body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px 20px;
}

.category {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--label);
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 27px;
  line-height: 1.05;
}

/* Stretched over the whole card, so the card is one tap target. */
.link::after {
  content: '';
  position: absolute;
  inset: 0;
}

.card:hover .title {
  color: var(--primary);
}

.text {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary);
}

/* Rating and duration sit at the bottom, just over the price, so they line up
   across a row of cards whatever the length of the titles. */
.facts {
  margin-top: auto;
}

.facts + .footer {
  margin-top: 0;
}

.footer {
  margin-top: auto;
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.price {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-body);
}

.place {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-body);
}

.placeIcon {
  flex: none;
}

.arrow {
  width: 44px;
  height: 44px;
  flex: none;
  border-radius: 50%;
  border: 1px solid var(--text);
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 1024px) {
  .image {
    height: 290px;
  }

  .save {
    top: 12px;
    right: 12px;
  }

  .saveIcon {
    width: 26px;
    height: 26px;
  }

  .body {
    gap: 10px;
    padding: 24px 28px;
  }

  .category {
    font-size: 11px;
    letter-spacing: 0.24em;
  }

  .title {
    font-size: 32px;
  }

  .text {
    max-width: 300px;
    font-size: 15px;
  }

  .footer {
    padding-top: 10px;
    gap: 12px;
  }

  .place {
    gap: 8px;
    font-size: 13px;
  }

  .placeIcon {
    width: 16px;
    height: 16px;
  }

  .arrow {
    width: 46px;
    height: 46px;
  }

  .arrowIcon {
    width: 16px;
    height: 16px;
  }
}
